<template>
  <div class="dizme_tm_section" id="features">
    <div class="dizme_tm_services">
      <div class="container">
        <div class="dizme_tm_main_title features-header" data-align="center">
          <span>Features</span>
          <h3>Here's how <span style="color: #8067f0;">MyPBE</span> works ...</h3>
          <p>
            Discover the powerful tools that can <span style="color: #1cbe59;">enhance</span> 
            your <span style="color: #f75023;">PBE preparation</span>
          </p>
          <div class="features-cta-container">
            <div class="dizme_tm_button wow fadeInUp" data-wow-duration="1s">
              <a class="anchor features-cta-button" href="https://app.mypbe.com/study-plan">
                <span>📋 Detailed Study Plan</span>
              </a>
            </div>
          </div>
        </div>
        <div class="service_list">
          <ul>
            <li
              class="wow fadeInLeft"
              data-wow-duration="1s"
              @click.prevent="active = 1"
            >
              <div class="list_inner tilt-effect">
                <span class="icon">
                  <img class="svg" src="/img/svg/service/anchor.svg" alt="" />
                  <img
                    class="back"
                    :src="`/img/brushes/service${dark ? '/dark' : ''}/1.png`"
                    alt=""
                  />
                </span>
                <div class="title">
                  <h3>Interactive First Letters</h3>
                </div>
                <div class="">
                  <p>
                    The Interactive First Letters tool helps you memorize scripture by displaying the first letter of each word in your study chapters. With the ability to reveal full words or entire verses at the click of a button, this feature supports your memory retention in a simple, yet effective manner. Available in the free tier, it's a great starting point for your PBE preparation.
                  </p>
                </div>
                <a class="dizme_tm_full_link" href="#"></a>
                <img
                  class="popup_service_image"
                  src="/img/service/1.jpg"
                  alt=""
                />
              </div>
            </li>
            <li
              class="wow fadeInRight"
              data-wow-duration="1s"
              data-wow-delay="0.2s"
              @click.prevent="active = 2"
            >
              <div class="list_inner tilt-effect">
                <span class="icon">
                  <img class="svg" src="/img/svg/service/physics.svg" alt="" />
                  <img
                    class="back"
                    :src="`/img/brushes/service${dark ? '/dark' : ''}/2.png`"
                    alt=""
                  />
                </span>
                <div class="title">
                  <h3>Chapter Drills</h3>
                  <!-- <span class="price">Starts from <span>$199</span></span> -->
                </div>
                <div class="text">
                  <p>
                    Chapter Drills offer a fun and challenging way to test your verse-by-verse knowledge with fill-in-the-blank exercises. You select a chapter and difficulty level, then complete multiple-choice blanks under a time limit. Earn points for each correct word and enhance your memorization skills through this engaging practice method. Perfect for sharpening your focus on specific chapters!
                  </p>
                </div>
                <a class="dizme_tm_full_link" href="#"></a>
                <img
                  class="popup_service_image"
                  src="/img/service/2.jpg"
                  alt=""
                />
                <div class="service_hidden_details">
                  <div class="service_popup_informations">
                    <div class="descriptions">
                      <p>
                        Dizme is a leading web design agency with an
                        award-winning design team that creates innovative,
                        effective websites that capture your brand, improve your
                        conversion rates, and maximize your revenue to help grow
                        your business and achieve your goals.
                      </p>
                      <p>
                        In today’s digital world, your website is the first
                        interaction consumers have with your business. That's
                        why almost 95 percent of a user’s first impression
                        relates to web design. It’s also why web design services
                        can have an immense impact on your company’s bottom
                        line.
                      </p>
                      <p>
                        That’s why more companies are not only reevaluating
                        their website’s design but also partnering with Kura,
                        the web design agency that’s driven more than $2.4
                        billion in revenue for its clients. With over 50 web
                        design awards under our belt, we're confident we can
                        design a custom website that drives sales for your
                        unique business.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li
              class="wow fadeInRight"
              data-wow-duration="1s"
              data-wow-delay="0.2s"
              @click.prevent="active = 3"
            >
              <div class="list_inner tilt-effect">
                <span class="icon">
                  <img class="svg" src="/img/svg/service/contact.svg" alt="" />
                  <img
                    class="back"
                    :src="`/img/brushes/service${dark ? '/dark' : ''}/3.png`"
                    alt=""
                  />
                </span>
                <div class="title">
                  <h3>ABC Study Questions</h3>
                </div>
                <div class="text">
                  <p>
                    ABC Study Questions support your mastery of the Adventist Bible Commentary content for the focus books.
                  </p>
                </div>
                <a class="dizme_tm_full_link" href="#"></a>
                <img
                  class="popup_service_image"
                  src="/img/service/3.jpg"
                  alt=""
                />
              </div>
            </li>
            <li
              class="wow fadeInLeft"
              data-wow-duration="1s"
              @click.prevent="active = 3"
            >
              <div class="list_inner tilt-effect">
                <span class="icon">
                  <img class="svg" src="/img/svg/service/contact.svg" alt="" />
                  <img
                    class="back"
                    :src="`/img/brushes/service${dark ? '/dark' : ''}/3.png`"
                    alt=""
                  />
                </span>
                <div class="title">
                  <h3>Lightning Challenges</h3>
                  <!-- <span class="price">Starts from <span>$299</span></span> -->
                </div>
                <div class="text">
                  <p>
                    Lightning Challenges elevate your study sessions by presenting multiple-choice questions that test your understanding of your study chapters. In just 60 seconds, answer questions drawn from verses where you need the most practice or have not encountered before. Your performance impacts your Readiness Scores and adds Activity Points, making these fast-paced quizzes both rewarding and educational.
                  </p>
                </div>
                <a class="dizme_tm_full_link" href="#"></a>
                <img
                  class="popup_service_image"
                  src="/img/service/3.jpg"
                  alt=""
                />
                <div class="service_hidden_details">
                  <div class="service_popup_informations">
                    <div class="descriptions">
                      <p>
                        Dizme is a leading web design agency with an
                        award-winning design team that creates innovative,
                        effective websites that capture your brand, improve your
                        conversion rates, and maximize your revenue to help grow
                        your business and achieve your goals.
                      </p>
                      <p>
                        In today’s digital world, your website is the first
                        interaction consumers have with your business. That's
                        why almost 95 percent of a user’s first impression
                        relates to web design. It’s also why web design services
                        can have an immense impact on your company’s bottom
                        line.
                      </p>
                      <p>
                        That’s why more companies are not only reevaluating
                        their website’s design but also partnering with Kura,
                        the web design agency that’s driven more than $2.4
                        billion in revenue for its clients. With over 50 web
                        design awards under our belt, we're confident we can
                        design a custom website that drives sales for your
                        unique business.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li
              class="wow fadeInRight"
              data-wow-duration="1s"
              data-wow-delay="0.2s"
              @click.prevent="active = 4"
            >
              <div class="list_inner tilt-effect">
                <span class="icon">
                  <img class="svg" src="/img/svg/service/web.svg" alt="" />
                  <img
                    class="back"
                    :src="`/img/brushes/service${dark ? '/dark' : ''}/1.png`"
                    alt=""
                  />
                </span>
                <div class="title">
                  <h3>Assessments</h3>
                  <!-- <span class="price">Starts from <span>$399</span></span> -->
                </div>
                <div class="text">
                  <p>
                    Assessments drill deeper into your comprehension with short answer questions based on your study chapters. Answer 12 questions within a set time limit and earn Activity Points based on your correct responses. These assessments not only boost your Readiness Scores but also provide a thorough review of your biblical knowledge, ensuring you're well-prepared for the competition.
                  </p>
                </div>
                <a class="dizme_tm_full_link" href="#"></a>
                <img
                  class="popup_service_image"
                  src="/img/service/4.jpg"
                  alt=""
                />
                <div class="service_hidden_details">
                  <div class="service_popup_informations">
                    <div class="descriptions">
                      <p>
                        Dizme is a leading web design agency with an
                        award-winning design team that creates innovative,
                        effective websites that capture your brand, improve your
                        conversion rates, and maximize your revenue to help grow
                        your business and achieve your goals.
                      </p>
                      <p>
                        In today’s digital world, your website is the first
                        interaction consumers have with your business. That's
                        why almost 95 percent of a user’s first impression
                        relates to web design. It’s also why web design services
                        can have an immense impact on your company’s bottom
                        line.
                      </p>
                      <p>
                        That’s why more companies are not only reevaluating
                        their website’s design but also partnering with Kura,
                        the web design agency that’s driven more than $2.4
                        billion in revenue for its clients. With over 50 web
                        design awards under our belt, we're confident we can
                        design a custom website that drives sales for your
                        unique business.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li
              class="wow fadeInRight"
              data-wow-duration="1s"
              data-wow-delay="0.2s"
              @click.prevent="active = 5"
            >
              <div class="list_inner tilt-effect">
                <span class="icon">
                  <img class="svg" src="/img/intro/badge.png" alt="" />
                  <img
                    class="back"
                    :src="`/img/brushes/service${dark ? '/dark' : ''}/4.png`"
                    alt=""
                  />
                </span>
                <div class="title">
                  <h3>Readiness Scores</h3>
                  <!-- <span class="price">Starts from <span>$399</span></span> -->
                </div>
                <div class="text">
                  <p>
                    Readiness Scores offer a comprehensive overview of your preparedness for the PBE competition. Calculated based on your responses to various questions, these scores provide a percentage that reflects your mastery over specific verses, chapters, and your overall study chapters. As you approach 100% readiness, you'll move up through different ranks, keeping you motivated and focused on your goal.
                  </p>
                </div>
                <a class="dizme_tm_full_link" href="#"></a>
                <img
                  class="popup_service_image"
                  src="/img/service/4.jpg"
                  alt=""
                />
                <div class="service_hidden_details">
                  <div class="service_popup_informations">
                    <div class="descriptions">
                      <p>
                        Dizme is a leading web design agency with an
                        award-winning design team that creates innovative,
                        effective websites that capture your brand, improve your
                        conversion rates, and maximize your revenue to help grow
                        your business and achieve your goals.
                      </p>
                      <p>
                        In today’s digital world, your website is the first
                        interaction consumers have with your business. That's
                        why almost 95 percent of a user’s first impression
                        relates to web design. It’s also why web design services
                        can have an immense impact on your company’s bottom
                        line.
                      </p>
                      <p>
                        That’s why more companies are not only reevaluating
                        their website’s design but also partnering with Kura,
                        the web design agency that’s driven more than $2.4
                        billion in revenue for its clients. With over 50 web
                        design awards under our belt, we're confident we can
                        design a custom website that drives sales for your
                        unique business.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li
              class="wow fadeInRight"
              data-wow-duration="1s"
              data-wow-delay="0.2s"
              @click.prevent="active = 6"
            >
              <div class="list_inner tilt-effect">
                <span class="icon">
                  <img class="svg" src="/img/intro/trophy.png" alt="" />
                  <img
                    class="back"
                    :src="`/img/brushes/service${dark ? '/dark' : ''}/2.png`"
                    alt=""
                  />
                </span>
                <div class="title">
                  <h3>Leaderboards</h3>
                  <!-- <span class="price">Starts from <span>$399</span></span> -->
                </div>
                <div class="text">
                  <p>
                    Leaderboards add an element of friendly competition by showcasing the top performers based on Activity Points. View the highest scorers for the current week, month, or of all time, and see where you stand among your peers. It's a fun way to stay motivated and push yourself to engage more with the various features of the site. Previous leaderboards are also available, allowing you to track ongoing progress over multiple timeframes.
                  </p>
                </div>
                <a class="dizme_tm_full_link" href="#"></a>
                <img
                  class="popup_service_image"
                  src="/img/service/4.jpg"
                  alt=""
                />
                <div class="service_hidden_details">
                  <div class="service_popup_informations">
                    <div class="descriptions">
                      <p>
                        Dizme is a leading web design agency with an
                        award-winning design team that creates innovative,
                        effective websites that capture your brand, improve your
                        conversion rates, and maximize your revenue to help grow
                        your business and achieve your goals.
                      </p>
                      <p>
                        In today’s digital world, your website is the first
                        interaction consumers have with your business. That's
                        why almost 95 percent of a user’s first impression
                        relates to web design. It’s also why web design services
                        can have an immense impact on your company’s bottom
                        line.
                      </p>
                      <p>
                        That’s why more companies are not only reevaluating
                        their website’s design but also partnering with Kura,
                        the web design agency that’s driven more than $2.4
                        billion in revenue for its clients. With over 50 web
                        design awards under our belt, we're confident we can
                        design a custom website that drives sales for your
                        unique business.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li
              class="wow fadeInRight"
              data-wow-duration="1s"
              data-wow-delay="0.2s"
              @click.prevent="active = 7"
            >
              <div class="list_inner tilt-effect">
                <span class="icon">
                  <img class="svg" src="/img/intro/trophy.png" alt="" />
                  <img
                    class="back"
                    :src="`/img/brushes/service${dark ? '/dark' : ''}/2.png`"
                    alt=""
                  />
                </span>
                <div class="title">
                  <h3>Activity Feed</h3>
                </div>
                <div class="text">
                  <p>
                    The Activity Feed provides detailed updates of the activity of your connections. You can follow their progress, and react to their accomplishments.
                  </p>
                </div>
                <a class="dizme_tm_full_link" href="#"></a>
                <img
                  class="popup_service_image"
                  src="/img/service/4.jpg"
                  alt=""
                />
                <div class="service_hidden_details">
                  <div class="service_popup_informations">
                    <div class="descriptions">
                      <p>
                        Dizme is a leading web design agency with an
                        award-winning design team that creates innovative,
                        effective websites that capture your brand, improve your
                        conversion rates, and maximize your revenue to help grow
                        your business and achieve your goals.
                      </p>
                      <p>
                        In today's digital world, your website is the first
                        interaction consumers have with your business. That's
                        why almost 95 percent of a user's first impression
                        relates to web design. It's also why web design services
                        can have an immense impact on your company's bottom
                        line.
                      </p>
                      <p>
                        That's why more companies are not only reevaluating
                        their website's design but also partnering with Kura,
                        the web design agency that's driven more than $2.4
                        billion in revenue for its clients. With over 50 web
                        design awards under our belt, we're confident we can
                        design a custom website that drives sales for your
                        unique business.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li
              class="wow fadeInLeft"
              data-wow-duration="1s"
              data-wow-delay="0.4s"
              @click.prevent="active = 8"
            >
              <div class="list_inner tilt-effect">
                <span class="icon">
                  <img class="svg" src="/img/intro/pro.png" alt="" />
                  <img
                    class="back"
                    :src="`/img/brushes/service${dark ? '/dark' : ''}/3.png`"
                    alt=""
                  />
                </span>
                <div class="title">
                  <h3>Coach Corner</h3>
                </div>
                <div class="text">
                  <p>
                    Support your Pathfinders on their journey to PBE mastery with in-depth insight into their preparation. Available with a free tier account, Coach Corner provides you with the a wide variety of tools to help your team succeed.
                  </p>
                  <div class="coach-video-button" style="margin-top: 15px;">
                    <a class="video-link" @click.prevent.stop="openCoachVideo">
                      <span>
                        Watch Overview <img src="/img/slider/play.png" width="20px;" alt="play" />
                      </span>
                    </a>
                  </div>
                </div>
                <a class="dizme_tm_full_link" href="#"></a>
                <img
                  class="popup_service_image"
                  src="/img/service/4.jpg"
                  alt=""
                />
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="brush_1 wow fadeInLeft" data-wow-duration="1s">
        <img src="/img/brushes/service/5.png" alt="" />
      </div>
      <div class="brush_2 wow zoomIn" data-wow-duration="1s">
        <img src="/img/brushes/service/6.png" alt="" />
      </div>
    </div>
    <VideoPopup :show="isCoachVideoVisible" :videoUrl="coachVideoUrl" @close="isCoachVideoVisible = false" />
  </div>
  <!-- <div :class="active == 1 ? '' : 'service_hidden_details'">
    <ModalBox :close="close">
      <div class="service_popup_informations">
        <div class="image">
          <img src="img/thumbs/4-2.jpg" alt="" />
          <div
            class="main"
            data-img-url="img/service/1.jpg"
            style="background-image: url('img/service/1.jpg')"
          ></div>
        </div>
        <div class="main_title">
          <h3>Creative Design</h3>
          <span class="price">Starts from <span>$99</span></span>
        </div>
        <div class="descriptions">
          <p>
            Dizme is a leading web design agency with an award-winning design
            team that creates innovative, effective websites that capture your
            brand, improve your conversion rates, and maximize your revenue to
            help grow your business and achieve your goals.
          </p>
          <p>
            In today’s digital world, your website is the first interaction
            consumers have with your business. That's why almost 95 percent of a
            user’s first impression relates to web design. It’s also why web
            design services can have an immense impact on your company’s bottom
            line.
          </p>
          <p>
            That’s why more companies are not only reevaluating their website’s
            design but also partnering with Kura, the web design agency that’s
            driven more than $2.4 billion in revenue for its clients. With over
            50 web design awards under our belt, we're confident we can design a
            custom website that drives sales for your unique business.
          </p>
        </div>
      </div>
    </ModalBox>
  </div>
  <div :class="active == 2 ? '' : 'service_hidden_details'">
    <ModalBox :close="close">
      <div class="service_popup_informations">
        <div class="image">
          <img src="img/thumbs/4-2.jpg" alt="" />
          <div
            class="main"
            data-img-url="img/service/2.jpg"
            style="background-image: url('img/service/2.jpg')"
          ></div>
        </div>
        <div class="main_title">
          <h3>Graphic Design</h3>
          <span class="price">Starts from <span>$199</span></span>
        </div>
        <div class="descriptions">
          <p>
            Dizme is a leading web design agency with an award-winning design
            team that creates innovative, effective websites that capture your
            brand, improve your conversion rates, and maximize your revenue to
            help grow your business and achieve your goals.
          </p>
          <p>
            In today’s digital world, your website is the first interaction
            consumers have with your business. That's why almost 95 percent of a
            user’s first impression relates to web design. It’s also why web
            design services can have an immense impact on your company’s bottom
            line.
          </p>
          <p>
            That’s why more companies are not only reevaluating their website’s
            design but also partnering with Kura, the web design agency that’s
            driven more than $2.4 billion in revenue for its clients. With over
            50 web design awards under our belt, we're confident we can design a
            custom website that drives sales for your unique business.
          </p>
        </div>
      </div>
    </ModalBox>
  </div>
  <div :class="active == 3 ? '' : 'service_hidden_details'">
    <ModalBox :close="close">
      <div class="service_popup_informations">
        <div class="image">
          <img src="img/thumbs/4-2.jpg" alt="" />
          <div
            class="main"
            data-img-url="img/service/3.jpg"
            style="background-image: url('img/service/3.jpg')"
          ></div>
        </div>
        <div class="main_title">
          <h3>UI/UX Design</h3>
          <span class="price">Starts from <span>$299</span></span>
        </div>
        <div class="descriptions">
          <p>
            Dizme is a leading web design agency with an award-winning design
            team that creates innovative, effective websites that capture your
            brand, improve your conversion rates, and maximize your revenue to
            help grow your business and achieve your goals.
          </p>
          <p>
            In today’s digital world, your website is the first interaction
            consumers have with your business. That's why almost 95 percent of a
            user’s first impression relates to web design. It’s also why web
            design services can have an immense impact on your company’s bottom
            line.
          </p>
          <p>
            That’s why more companies are not only reevaluating their website’s
            design but also partnering with Kura, the web design agency that’s
            driven more than $2.4 billion in revenue for its clients. With over
            50 web design awards under our belt, we're confident we can design a
            custom website that drives sales for your unique business.
          </p>
        </div>
      </div>
    </ModalBox>
  </div>
  <div :class="active == 4 ? '' : 'service_hidden_details'">
    <ModalBox :close="close">
      <div class="service_popup_informations">
        <div class="image">
          <img src="img/thumbs/4-2.jpg" alt="" />
          <div
            class="main"
            data-img-url="img/service/4.jpg"
            style="background-image: url('img/service/4.jpg')"
          ></div>
        </div>
        <div class="main_title">
          <h3>Web Design</h3>
          <span class="price">Starts from <span>$399</span></span>
        </div>
        <div class="descriptions">
          <p>
            Dizme is a leading web design agency with an award-winning design
            team that creates innovative, effective websites that capture your
            brand, improve your conversion rates, and maximize your revenue to
            help grow your business and achieve your goals.
          </p>
          <p>
            In today’s digital world, your website is the first interaction
            consumers have with your business. That's why almost 95 percent of a
            user’s first impression relates to web design. It’s also why web
            design services can have an immense impact on your company’s bottom
            line.
          </p>
          <p>
            That’s why more companies are not only reevaluating their website’s
            design but also partnering with Kura, the web design agency that’s
            driven more than $2.4 billion in revenue for its clients. With over
            50 web design awards under our belt, we're confident we can design a
            custom website that drives sales for your unique business.
          </p>
        </div>
      </div>
    </ModalBox>
  </div> -->
</template>

<script>
// import ModalBox from "./popup/ModalBox.vue";
import VideoPopup from "./popup/VideoPopup.vue";

export default {
  name: "FeaturesComponent",
  data() {
    return {
      active: 0,
      isCoachVideoVisible: false,
      coachVideoUrl: "https://www.youtube.com/embed/JEWbofo-WSo",
    };
  },
  mounted() {
    // let VanillaTilt = require("vanilla-tilt");
    // VanillaTilt.init(document.querySelectorAll(".tilt-effect"), {
    //   maxTilt: 6,
    //   easing: "cubic-bezier(.03,.98,.52,.99)",
    //   speed: 500,
    //   transition: true,
    // });
  },
  methods: {
    close() {
      this.active = 0;
    },
    openCoachVideo() {
      console.log("openCoachVideo");
      this.isCoachVideoVisible = true;
    },
  },
  components: { VideoPopup },
  props: {
    dark: { type: Boolean },
  },
};
</script>

<style scoped>
/* Accent presets for each feature card (keeps it simple and colorful) */
#features .service_list li:nth-child(1) { --card-accent: #00D4BD; --card-accent-soft: rgba(0,212,189,0.10); }
#features .service_list li:nth-child(2) { --card-accent: #fa5b0f; --card-accent-soft: rgba(250,91,15,0.10); }
#features .service_list li:nth-child(3) { --card-accent: #9200ee; --card-accent-soft: rgba(146,0,238,0.10); }
#features .service_list li:nth-child(4) { --card-accent: #66B95C; --card-accent-soft: rgba(102,185,92,0.10); }
#features .service_list li:nth-child(5) { --card-accent: #4169e1; --card-accent-soft: rgba(65,105,225,0.10); }
#features .service_list li:nth-child(6) { --card-accent: #e54b4b; --card-accent-soft: rgba(229,75,75,0.10); }
#features .service_list li:nth-child(7) { --card-accent: #ff9500; --card-accent-soft: rgba(255,149,0,0.10); }
#features .service_list li:nth-child(8) { --card-accent: #007AFF; --card-accent-soft: rgba(0,122,255,0.10); }

#features .service_list li .list_inner {
  position: relative;
  background: linear-gradient(180deg, var(--card-accent-soft, rgba(0,0,0,0.03)) 0%, rgba(255,255,255,0.95) 100%);
  border: 1px solid rgba(0,0,0,0.06);
  border-radius: 16px;
  box-shadow: 0 6px 16px rgba(0,0,0,0.06);
  transition: transform .2s ease, box-shadow .2s ease;
}

#features .service_list li .list_inner:before {
  content: "";
  position: absolute;
  inset: 0;
  border-top: 3px solid var(--card-accent, rgba(0,0,0,0.08));
  border-radius: inherit;
  pointer-events: none;
  opacity: .6;
}

#features .service_list li .list_inner:hover,
#features .service_list li .list_inner:focus-within {
  transform: translateY(-4px);
  box-shadow: 0 10px 28px rgba(0,0,0,0.10);
}

#features .service_list li .icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: radial-gradient(120% 120% at 50% 0%, var(--card-accent-soft, rgba(0,0,0,0.05)) 0%, rgba(255,255,255,0.9) 100%);
  box-shadow: 0 6px 18px rgba(0,0,0,0.06), 0 0 0 3px var(--card-accent-soft, rgba(0,0,0,0.05));
}

#features .service_list li .icon .svg {
  width: 28px;
  height: 28px;
  color: var(--card-accent, #f75023);
}

#features .service_list li .title h3 {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 8px;
  background: rgba(0,0,0,0.02);
}

#features .dizme_tm_button .anchor {
  background-image: linear-gradient(90deg, #f75023 0%, #ff8a4c 100%);
  color: #fff;
  border: none;
}

body.dark #features .service_list li .list_inner {
  background: linear-gradient(180deg, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0.03) 100%);
  border-color: rgba(255,255,255,0.10);
  box-shadow: 0 6px 16px rgba(0,0,0,0.25);
}

body.dark #features .service_list li .list_inner:before {
  opacity: .8;
}

@media (max-width: 768px) {
  #features .container {
    padding-left: 16px;
    padding-right: 16px;
  }

  #features .dizme_tm_main_title span {
    font-size: 13px;
  }

  #features .dizme_tm_main_title h3 {
    font-size: 22px;
    line-height: 1.3;
  }

  #features .dizme_tm_button {
    margin-bottom: 18px;
  }

  #features .dizme_tm_button .anchor {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 44px;
    border-radius: 12px;
  }

  #features .dizme_tm_button .anchor span {
    padding: 12px 16px;
    font-size: 15px;
  }

  #features .service_list ul {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
  }

  #features .service_list li .list_inner {
    padding: 16px;
    border-radius: 16px;
  }

  /* Hide the icon block on mobile to keep text readable (like before) */
  #features .service_list li .icon {
    display: none !important;
  }

  #features .service_list li .icon .svg {
    width: 32px;
    height: 32px;
  }

  #features .service_list li .title h3 {
    font-size: 18px;
  }

  #features .service_list li .text p,
  #features .service_list li p {
    font-size: 14px;
    line-height: 1.6;
  }

  #features .popup_service_image {
    display: none;
  }

  #features .brush_1,
  #features .brush_2 {
    display: none;
  }
}

@media (max-width: 480px) {
  #features .dizme_tm_main_title h3 {
    font-size: 20px;
  }

  #features .service_list ul {
    gap: 12px;
  }

  #features .service_list li .list_inner {
    padding: 14px;
    border-radius: 12px;
  }
}

.features-header {
  background: linear-gradient(135deg, rgba(102, 185, 92, 0.1) 0%, rgba(250, 91, 15, 0.1) 50%, rgba(146, 0, 238, 0.1) 100%);
  padding: 40px 20px;
  border-radius: 20px;
  margin-bottom: 40px;
  position: relative;
  overflow: hidden;
}

.features-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 30% 20%, rgba(102, 185, 92, 0.15) 0%, transparent 50%),
              radial-gradient(circle at 70% 80%, rgba(250, 91, 15, 0.15) 0%, transparent 50%),
              radial-gradient(circle at 50% 50%, rgba(146, 0, 238, 0.1) 0%, transparent 50%);
  z-index: -1;
}

.features-header h3 {
  margin-bottom: 20px;
}

.features-header p {
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.7;
}

@media (max-width: 768px) {
  .features-header {
    padding: 30px 15px;
    border-radius: 15px;
    margin-bottom: 30px;
  }

  .features-header h3 {
    font-size: 24px;
    margin-bottom: 15px;
  }

  .features-header p {
    font-size: 16px;
    line-height: 1.6;
  }
}

@media (max-width: 480px) {
  .features-header {
    padding: 25px 10px;
    border-radius: 12px;
  }

  .features-header h3 {
    font-size: 22px;
  }

  .features-header p {
    font-size: 15px;
  }
}

.features-header span {
  font-family: inherit !important;
  font-weight: inherit !important;
  font-size: inherit !important;
  font-style: inherit !important;
  text-decoration: inherit !important;
  letter-spacing: inherit !important;
  line-height: inherit !important;
}

.features-cta-container {
  margin-top: 30px;
  text-align: center;
}

.features-cta-button {
  background: linear-gradient(135deg, #d73d1a 0%, #f75023 50%, #ff6b35 100%) !important;
  border: none !important;
  padding: 16px 32px !important;
  border-radius: 50px !important;
  font-weight: 700 !important;
  font-size: 16px !important;
  color: #ffffff !important;
  text-decoration: none !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
  box-shadow: 0 8px 25px rgba(247, 80, 35, 0.35) !important;
  transition: all 0.3s ease !important;
  position: relative !important;
  overflow: hidden !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3) !important;
}

.features-cta-button:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 12px 35px rgba(247, 80, 35, 0.45) !important;
  background: linear-gradient(135deg, #e64a1f 0%, #f75023 50%, #ff6b35 100%) !important;
}

.features-cta-button:before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
  transition: left 0.5s ease;
}

.features-cta-button:hover:before {
  left: 100%;
}

.features-cta-button span {
  color: #ffffff !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3) !important;
  font-weight: inherit !important;
}

@media (max-width: 768px) {
  .features-cta-container {
    margin-top: 25px;
  }
  
  .features-cta-button {
    padding: 14px 28px !important;
    font-size: 15px !important;
    border-radius: 40px !important;
  }
}

@media (max-width: 480px) {
  .features-cta-container {
    margin-top: 20px;
  }
  
  .features-cta-button {
    padding: 12px 24px !important;
    font-size: 14px !important;
    border-radius: 35px !important;
    width: 90%;
    max-width: 280px;
  }
}

.coach-video-button .video-link {
  text-decoration: none;
  color: #007AFF;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: 'Jost', sans-serif;
  font-weight: 500;
  border-radius: 25px;
  border: 2px solid #007AFF;
  padding: 8px 16px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  font-size: 14px;
  background: rgba(255,255,255,0.8);
  z-index: 10;
}

.coach-video-button .video-link:hover {
  background: #007AFF;
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0,122,255,0.3);
}

.coach-video-button .video-link span {
  position: relative;
  z-index: 2;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}

@media (max-width: 768px) {
  .coach-video-button .video-link {
    padding: 6px 12px;
    font-size: 13px;
    border-radius: 20px;
  }
}
</style>
